import React from "react";
import { SEO } from "@qgiv/core-donor";
import ConnectedDonationFormReceiptBase from "../templates/DonationFormReceiptBase";
import ConnectedRecurringSummaryPageContent from "./RecurringSummaryPageContent";
import DonationFormFooter from "../templates/DonationFooterBase/DonationFormFooter";

/**
 * @param {object} props
 * @param {string} props.documentTitle
 * @returns {React.JSX.Element}
 */
const RecurringSummaryPage = ({ documentTitle = "" }) => (
    <ConnectedDonationFormReceiptBase>
        <SEO title={documentTitle} description="" />
        <ConnectedRecurringSummaryPageContent />
        <DonationFormFooter showDigiCert={false} />
    </ConnectedDonationFormReceiptBase>
);

export default RecurringSummaryPage;
